import React from 'react';
import {useIntl} from 'react-intl';
import {getPerformanceInfoAndVariant} from '../../ProjectHealthLogic';
import {StatsContainer, StatContainer, StatValue, StatTitle} from './PerformanceModal.styled';

export const PerformanceModalStatsSection = ({performanceRolling, performanceTotal}) => {
	const intl = useIntl();
	const performanceRollingWarningInfo = getPerformanceInfoAndVariant(performanceRolling);
	const performanceTotalWarningInfo = getPerformanceInfoAndVariant(performanceTotal);

	return (
		<StatsContainer>
			<StatContainer>
				<StatValue color={performanceRollingWarningInfo.variant.color}>
					{intl.formatNumber(performanceRolling * 100) + '%'}
				</StatValue>
				<StatTitle>30 days</StatTitle>
			</StatContainer>
			<StatContainer>
				<StatValue color={performanceTotalWarningInfo.variant.color}>
					{intl.formatNumber(performanceTotal * 100) + '%'}
				</StatValue>
				<StatTitle>Average</StatTitle>
			</StatContainer>
		</StatsContainer>
	);
};
